import React from 'react'
import {
  StyledCopyright,
  FooterRow,
  SitemapTerms,
  CopyrightText,
  RightBorderLink,
  CookiePreferencesButton,
} from '../style'
import { Container } from '../../Globals'
import { useTranslatedTerms } from '@hooks'
import { openConsentPreferences } from '@utils'

const Copyright = ({
  data: { globalPrivacy, termsAndConditions },
  title = 'Paul Hastings, LLP',
}) => {
  const { getTranslatedTerm } = useTranslatedTerms()

  return (
    <StyledCopyright>
      <Container>
        <FooterRow>
          <CopyrightText>
            {`Copyright © ${new Date().getFullYear()} ${title}. All rights reserved.`}
          </CopyrightText>
          <SitemapTerms>
            <RightBorderLink to="sitemap">Sitemap</RightBorderLink>
            {termsAndConditions && (
              <RightBorderLink to={termsAndConditions.slug}>
                {termsAndConditions.title}
              </RightBorderLink>
            )}
            {globalPrivacy && (
              <RightBorderLink to={globalPrivacy.slug}>
                {globalPrivacy.title}
              </RightBorderLink>
            )}
            <CookiePreferencesButton
              type="button"
              onClick={openConsentPreferences}
            >
              {getTranslatedTerm('Cookie Settings')}
            </CookiePreferencesButton>
          </SitemapTerms>
        </FooterRow>
      </Container>
    </StyledCopyright>
  )
}

Copyright.propTypes = {}

export default Copyright
